export enum CalculationInstallerSummaryTypeEnum {
  CustomerData = 'customerData',
  BuildingDetails = 'buildingDetails',
  Installations = 'installations',
  Sanitary = 'sanitary',
}
